<template lang="">
  <div class="container">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="企业代号" prop="code">
        <Input
          disabled
          v-model="formValidate.code"
          placeholder="请输入4位数代号"
        ></Input>
      </FormItem>
      <FormItem label="企业名称" prop="name">
        <Input v-model="formValidate.name" placeholder="请输入企业名称"></Input>
      </FormItem>
      <FormItem label="负责人" prop="inCharge">
        <Input
          v-model="formValidate.inCharge"
          placeholder="请输入负责人"
        ></Input>
      </FormItem>
      <FormItem label="手机号" prop="phone">
        <Input
          v-model="formValidate.phone"
          placeholder="请输入联系号码"
        ></Input>
      </FormItem>
      <FormItem label="账号" prop="account">
        <Input
          disabled
          v-model="formValidate.account"
          placeholder="请设置账号"
        ></Input>
      </FormItem>
      <FormItem label="密码" prop="password">
        <Input v-model="formValidate.password" placeholder="请设置密码"></Input>
      </FormItem>
      <FormItem label="到期时间">
        <Row>
          <FormItem prop="date">
            <DatePicker
              type="date"
              placeholder="日期"
              v-model="formValidate.date"
            ></DatePicker>
          </FormItem>
        </Row>
      </FormItem>
      <!-- <FormItem label="Gender" prop="gender">
                <RadioGroup v-model="formValidate.gender">
                    <Radio label="male">Male</Radio>
                    <Radio label="female">Female</Radio>
                </RadioGroup>
            </FormItem> -->
      <FormItem label="模块" prop="module" @click.stop>
        <CheckboxGroup v-model="formValidate.module">
          <Checkbox @click.stop label="防伪"></Checkbox>
          <Checkbox @click.stop label="溯源"></Checkbox>
          <Checkbox @click.stop label="分发"></Checkbox>
          <Checkbox @click.stop label="防串货"></Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem label="备注" prop="desc">
        <Input
          v-model="formValidate.desc"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
          placeholder="备注信息..."
        ></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('formValidate')"
          >确认修改</Button
        >

        <!-- <Button @click="handleReset('formValidate')" style="margin-left: 8px">Reset</Button> -->
      </FormItem>

      <FormItem label="发货表:" prop="desc">
        <span v-if="!tallyBool" style="color: red">未创建</span>
        <span v-if="tallyBool" style="color: blue">已创建</span>
        <span v-if="!tallyBool" style="color: blue;" @click="newTallys()">  创建</span>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { updataClients, GetTallyBool,newTally } from "@/api/index";
export default {
  props: ["datas"],
  data() {
    return {
      tallyBool: false,
      formValidate: {
        code: "", //企业代号
        name: "", //企业名称
        inCharge: "", //负责人
        phone: "", //负责人联系方式
        account: "", //账号
        password: "", //密码
        module: [], //模块
        date: "", //日期
        desc: "", //备注
      },
      ruleValidate: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        inCharge: [
          { required: true, message: "请填写负责人", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入负责人联系方式", trigger: "blur" },
        ],
        account: [
          { required: true, message: "请设置登录账号", trigger: "blur" },
        ],
      },
    };
  },
  updated() {
    GetTallyBool({
      code: this.formValidate.code,
    }).then((res) => {
      this.tallyBool = res;
    });
  },
  methods: {
    newTallys(){
      newTally({
        code: this.formValidate.code,
      }).then((res) => {
          this.tallyBool = res;
          this.$Message.success("创建成功");
      });
    },
    NewClient() {
      updataClients({
        code: this.formValidate.code, //企业代号
        name: this.formValidate.name, //企业名称
        inCharge: this.formValidate.inCharge, //负责人
        phone: this.formValidate.phone, //负责人联系方式
        account: this.formValidate.account, //账号
        password: this.formValidate.password, //密码
        module: JSON.stringify(this.formValidate.module), //模块
        date: this.formValidate.date, //日期
        desc: this.formValidate.desc, //备注
      }).then((res) => {
        if (res.success) {
          // $obj = {
          //   incode: this.formValidate.code,
          //   name: this.formValidate.name,
          //   account: this.formValidate.account,
          //   phone: this.formValidate.phone,
          //   incharge: this.formValidate.inCharge,
          //   module: JSON.stringify(this.formValidate.module),
          //   desc: this.formValidate.desc,
          //   date: this.formValidate.date,
          //   password: this.formValidate.password, //密码
          // };
          // console.log($obg);
          this.$emit("change", "");
          // this.formValidate = {};
          this.$Message.success("修改成功");
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.NewClient();
          // this.$Message.success('Success!');
        } else {
          this.$Message.error("请填写完整!");
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
  },
  watch: {
    datas(add, old) {
      this.formValidate = {
        code: add.incode, //企业代号
        name: add.name, //企业名称
        inCharge: add.incharge, //负责人
        phone: add.phone, //负责人联系方式
        account: add.account, //账号
        password: "", //密码
        city: add.city, //行业
        CodeLen: add.codeLen, //防伪位数
        module: JSON.parse(add.module), //模块
        date: add.date, //日期
        desc: add.desc, //备注
        address: "110000",
        DateAddress: add.site,
      };
    },
  },
};
</script>
<style scoped>
.container {
  width: 100%;
}
</style>
